module.exports = __webpack_public_path__ + "img/P2-C7.5f8a4020.svg";